import { Directive, ElementRef, HostListener, Renderer2, SecurityContext, Self } from '@angular/core';
import { NgControl } from '@angular/forms';
import { DomSanitizer } from '@angular/platform-browser';

@Directive({
  selector: '[trim-text]',
  standalone: false
})

export class TrimTextDirective {

  constructor(private element: ElementRef, private renderer: Renderer2, @Self() private ngControl: NgControl, private sanitizer: DomSanitizer) { }

  @HostListener('blur') onBlur() {
    let userInputValue = this.element.nativeElement.value.trim();
    const sanitizedValue = this.sanitizer.sanitize(SecurityContext.HTML, userInputValue) || '';
    this.renderer.setProperty(this.element.nativeElement, 'value', sanitizedValue);
    this.renderer.setAttribute(this.element.nativeElement, 'value', sanitizedValue);
    this.ngControl.control.patchValue(sanitizedValue);
  }

}